export const businessConfig = {
    ARASCO: {
        theme: "main", // main ARASCO theme
        inbound: {
            preReceiveAction: "releaseToQuality",
            disableActions: {

            }
        }
    },

    NLA: {

    }
}